import { connect } from 'react-redux'
import styled from '@emotion/styled'
import { selectIntegrationSettingsForProvider } from 'ducks/integrations'
import { selectCurrentTicketMailboxId } from 'selectors/tickets'
import {
  selectShouldShowCompanySection,
  selectShouldShowListSection,
  selectShouldShowDealSection,
} from 'ducks/integrations/hubspot/selectors'

import Card from './Card'

const select = state => {
  const settings = selectIntegrationSettingsForProvider(state, {
    provider: 'hubspot',
  })
  const mailboxId = selectCurrentTicketMailboxId(state)
  const key = `mailboxes.${mailboxId}`

  return {
    settings,
    showCompanySection: selectShouldShowCompanySection(state),
    showListSection: selectShouldShowListSection(state),
    showDealSection: selectShouldShowDealSection(state),
    shouldShowCard: settings[key],
  }
}

const StyledWrapper = styled('div')`
  & .card-content {
    padding: 0;
  }
  & > div {
    border: 0 !important;
  }
  border: 0;
  &:last-child {
    border-bottom: 1px solid ${props => props.theme.color.monochrome.medium};
  }
  &:last-child {
    border-bottom: 1px solid ${props => props.theme.color.monochrome.medium};
  }
  .sui & .ui.accordion:last-child {
    margin-bottom: 0;
  }
  .sui & ul {
    margin-bottom: 0;
  }
`

const Wrapper = ({ shouldShowCard, ...rest }) => {
  if (!shouldShowCard) return null
  return (
    <StyledWrapper>
      <Card {...rest} />
    </StyledWrapper>
  )
}

export default connect(select, null)(Wrapper)
